import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"

import PageTitle from "widget/PageTitle"
import DefaultButton from "shared/ui/DefaultButton"
import AgreeModal from "widget/AgreeModal"

import useGetRealExamList from "entity/tryoutExam/useGetRealExamList"

import tryoutTerm from "shared/constant/term/tryoutTerm"
import { convertProGradeAsName } from "shared/constant/lookup/proGrade"
import timestampCalculator from "shared/lib/timestampCalculator"

/**
 * @Desc 트라이아웃 실기 시험 리스트 Page
 * null 미응시
 * true 합격
 * false 불합격
*/
const TryoutRealExamList = () => {
    const navigate = useNavigate()

    const [isModalShow, setIsModalShow] = useState(false)
    const [proGradeType, setProGradeType] = useState(null)
    const [examIdx, setExamIdx] = useState(null)

    const [tryoutExamList] = useGetRealExamList()

    const tmpTerm = [
        {
            "title": "트라이아웃 실기 시험 결제 및 응시 약관 (필수)",
            "content": tryoutTerm
        }
    ]

    const examList = [
        tryoutExamList?.data?.rookie,
        tryoutExamList?.data?.semi,
        tryoutExamList?.data?.tour
    ]

    const showModalEvent = (elem) => {
        setIsModalShow(true)
        // setProGradeType(elem?.pro_grade_flag)
        setProGradeType("real")
        setExamIdx(elem?.idx)
    };

    // 해당부분에서 내 트라이아웃 필기시험

    return (
        <>
            {isModalShow && <AgreeModal
                title="약관 동의" closeEvent={() => setIsModalShow(state => !state)}
                list={tmpTerm}
                buttonLabel="결제하기" clickEvent={() => navigate(`/payment/real?proGradeType=${proGradeType}&examIdx=${examIdx}`)} />
            }

            <Style.Wrapper>
                <PageTitle>트라이아웃 실기 시험</PageTitle>

                <Style.ExamList>

                    {examList.map(elem =>
                        <Style.ExamElement>
                            <Style.ExamTitleDiv>
                                <h1>{convertProGradeAsName[elem?.pro_grade_flag]} Pro 실기 시험</h1>
                                <h2>{elem?.version}회차</h2>
                                <p>{timestampCalculator(elem?.created_at, "date")}</p>
                            </Style.ExamTitleDiv>
                            <Style.TakingButtonDiv>
                                {/* 임시주석 */}
                                <DefaultButton clickEvent={() => showModalEvent(elem)} small deactive={!elem?.is_available}>응시하기</DefaultButton>
                                {/* <DefaultButton clickEvent={() => showModalEvent(elem)} small >응시하기</DefaultButton> */}
                            </Style.TakingButtonDiv>
                        </Style.ExamElement>
                    )}

                </Style.ExamList>

            </Style.Wrapper>
        </>
    )
}

export default TryoutRealExamList